import axios from 'axios';
import CryptoJS from "crypto-js"
var base64gb2312 = require('../utils/base64gb2312.js')
export default {

	/**
	 * 过滤非法字符串显示
	 */
	normalString(str) {
		if (str == null || str == undefined || str == 'undefined') {
			return '';
		} else {
			return this.trim(str);
		}
	},
	trim(a) {
		return null == a ? "" : (a + "").replace(/(^\s*)|(\s*$)/g, "");
	},
	//判断字符是否为空
	isNullString(str) {
		if (str == null || str == undefined || str == '') {
			return true;
		} else
			return false;
	},
	/**
	 * 检验是否有特殊字符
	 */
	checkSpecial(str) {
		var reg = /[`~·!@#$%^&*()_+<>?？:"{}.。\\/;'[\]]/.test(str)
		return reg;
	},

	formatTime(date) {
		var year = date.getFullYear()
		var month = date.getMonth() + 1
		var day = date.getDate()

		var hour = date.getHours()
		var minute = date.getMinutes()
		var second = date.getSeconds()


		return [year, month, day].map(this.formatNumber).join('/') + ' ' + [hour, minute, second].map(this.formatNumber).join(
			':')
	},
	formatTime1(date) {
		var year = date.getFullYear()
		var month = date.getMonth() + 1
		var day = date.getDate()
		return [year, month, day].map(this.formatNumber).join('/')
	},
	transdate(endTime) {
		var date = new Date();
		date.setFullYear(endTime.substring(0, 4));
		date.setMonth(endTime.substring(5, 7) - 1);
		date.setDate(endTime.substring(8, 10));
		date.setHours(endTime.substring(11, 13));
		date.setMinutes(endTime.substring(14, 16));
		date.setSeconds(endTime.substring(17, 19));
		return Date.parse(date) / 1000;
	},
	getDate(tm) {
		var tt = new Date(parseInt(tm) * 1000).toLocaleString().replace(/年|月/g, "-").replace(/日/g, " ")
		return tt;
	},
	FormatDate(tm) {
		var date = this.formatTime(new Date(parseInt(tm)));
		return date;
	},
	FormatDate1(tm) {
		var date = this.formatTime1(new Date(parseInt(tm)));
		return date;
	},
	formatNumber(n) {
		n = n.toString()
		return n[1] ? n : '0' + n
	},
	//获取当前时间
	getCurrenDate() {
		var day2 = new Date();
		day2.setTime(day2.getTime());
		var s2 = day2.getFullYear() + "/" + (day2.getMonth() + 1) + "/" + day2.getDate();
		return s2;
	},
	addDate(date, days) {
		var d = new Date(date);
		d.setDate(d.getDate() + days);
		var m = d.getMonth() + 1;
		return d.getFullYear() + '/' + m + '/' + d.getDate();
	},
	compareDate(d1, d2) {
		return ((new Date(d1.replace(/-/g, "/"))) > (new Date(d2.replace(/-/g, "/"))));
	},
// 判断是否满足18岁

// 从身份证上提取年月日
 extract(cardNo,hosMinAge) {
	var sfzhmcode = cardNo;
	if (sfzhmcode.length == 18) {
	  this.birthday = sfzhmcode.slice(6, 14);
	  this.birthday = this.birthday.replace(/(.{4})(.{2})/, "$1-$2-");
	  console.log(this.birthday, '患者的身份证上的年月日')
	  var date = new Date(this.birthday);
	  var time1 = date.getTime();
	  return this.satisfy(time1,hosMinAge)
	}
  },
  /*
   * 判断平年闰年
   * y:年份数字，四位
   * */
 isOrdinaryYear(y) {
	if ((y % 4 === 0 && y % 100 !== 0) || y % 400 === 0) {
	  return false
	}
	return true;
  },
  /*
   * 判断是否满足18岁
   * time : 毫秒级时间戳，用户选中日期的时间戳
   * */
satisfy(time,hosMinAge) {
	var nowDate = new Date(); // 当前时间
	var mouth = nowDate.getMonth() + 1;
	var day = nowDate.getDate();
	var year = nowDate.getFullYear() - hosMinAge;
	if (mouth === 2 && day >= 28) {
	  day = this.isOrdinaryYear(year) ? 28 : 29;
	}
	var oldDate = new Date(year + '-' + mouth + '-' + day).getTime();
	console.log(oldDate < time ? '不满足' : '满足')
	return oldDate < time ? false : true;
	
  },
  
  
  // 判断是否满足18岁




	/**
	 * 身份证号码验证
	 *
	 */
	getIdCardInfo(cardNo) {
		var info = {
			isTrue: false,
			year: null,
			month: null,
			day: null,
			isMale: false,
			isFemale: false
		};
		if (!cardNo || (15 != cardNo.length && 18 != cardNo.length)) {
			info.isTrue = false;
			return info;
		}
		if (15 == cardNo.length) {
			let year = cardNo.substring(6, 8);
			let month = cardNo.substring(8, 10);
			let day = cardNo.substring(10, 12);
			let p = cardNo.substring(14, 15); //性别位
			let birthday = new Date(year, parseFloat(month) - 1,
				parseFloat(day));
			// 对于老身份证中的年龄则不需考虑千年虫问题而使用getYear()方法  
			if (birthday.getYear() != parseFloat(year) ||
				birthday.getMonth() != parseFloat(month) - 1 ||
				birthday.getDate() != parseFloat(day)) {
				info.isTrue = false;
			} else {
				info.isTrue = true;
				info.year = birthday.getFullYear();
				info.month = birthday.getMonth() + 1;
				info.day = birthday.getDate();
				if (p % 2 == 0) {
					info.isFemale = true;
					info.isMale = false;
				} else {
					info.isFemale = false;
					info.isMale = true
				}
			}
			return info;
		}
		if (18 == cardNo.length) {
			let year = cardNo.substring(6, 10);
			let month = cardNo.substring(10, 12);
			let day = cardNo.substring(12, 14);
			let p = cardNo.substring(14, 17)
			let birthday = new Date(year, parseFloat(month) - 1,
				parseFloat(day));
			// 这里用getFullYear()获取年份，避免千年虫问题
			if (birthday.getFullYear() != parseFloat(year) ||
				birthday.getMonth() != parseFloat(month) - 1 ||
				birthday.getDate() != parseFloat(day)) {
				info.isTrue = false;
				return info;
			}
			var Wi = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2, 1]; // 加权因子  
			var Y = [1, 0, 10, 9, 8, 7, 6, 5, 4, 3, 2]; // 身份证验证位值.10代表X 
			// 验证校验位
			var sum = 0; // 声明加权求和变量
			var _cardNo = cardNo.split("");

			if (_cardNo[17].toLowerCase() == 'x') {
				_cardNo[17] = 10; // 将最后位为x的验证码替换为10方便后续操作  
			}
			for (let i = 0; i < 17; i++) {
				sum += Wi[i] * _cardNo[i]; // 加权求和  
			}
			var i = sum % 11; // 得到验证码所位置

			if (_cardNo[17] != Y[i]) {
				return info.isTrue = false;
			}
			info.isTrue = true;
			info.year = birthday.getFullYear();
			info.month = birthday.getMonth() + 1;
			info.day = birthday.getDate();
			if (p % 2 == 0) {
				info.isFemale = true;
				info.isMale = false;
			} else {
				info.isFemale = false;
				info.isMale = true
			}
			return info;
		}
		return info;
	},
	/**
	 * 函数节流(防止多次点击)
	 */
	throttle(fn, gapTime) {
		if (gapTime == null || gapTime == undefined) {
			gapTime = 1500
		}

		let _lastTime = null

		// 返回新的函数
		return function () {
			let _nowTime = +new Date()
			if (_nowTime - _lastTime > gapTime || !_lastTime) {
				fn.apply(this, arguments) //将this和参数传给原函数
				_lastTime = _nowTime
			}
		}
	},

	// 验证姓名
	checkUserName(str) {
		var reg = /^[\u4e00-\u9fa5]+$/.test(str);
		return reg
	},

	// 新入埋点

	BuriedPoint(title, url, url_path, is_first_Day, preview, mdreferrer_title,) {
		console.log(title, url, url_path, 'buriedPoint埋点函数')
		let uuid = localStorage.getItem("userId");
		if (uuid == '' || uuid == undefined || uuid == null) {
			uuid = Date.parse(new Date()) + Date.parse(new Date())
		}
		//   var newProperties = wx.getStorageSync('newProperties')
		//   var title = util.getPageTitle(url_path)
		//   var referrer_title = util.getPageTitle(referrer)
		//   // console.log(uuid)
		//   const query = wx.createSelectorQuery()    

		var args = 'uuid=' + uuid + '&project_name=' + 'BNT' + '&platform_type=' + 'wxMp' + '&is_login=' + true +
			'&type=' + 'track' + '&event_type=' + preview + '&time=' + Date.parse(new Date())
		var properties = {
			"app_id": "wxb48b06bb3caf7bf0",
			"open_id": localStorage.getItem("openId"),
			"union_id": localStorage.getItem("unionId"),
			"app_version": "2.1.0",
			"ip": localStorage.getItem("ip"),
			"browser": "",
			"browser_version": "",
			"applet_version": "2.1.0",
			"brand": localStorage.getItem("model"),
			"model": localStorage.getItem("model"),
			"os": localStorage.getItem("iosAndro"),
			"os_version": localStorage.getItem("os"),
			"screen_height": localStorage.getItem("screeHeight"),
			"screen_width": localStorage.getItem("screenWidth"),
			"is_wifi": localStorage.getItem("is_wifi"),
			"carrier": "",
			"network_type": localStorage.getItem("network_type"),
			"is_first_day": is_first_Day,
			"title": title,
			"url": '/' + title,
			"url_path": '/' + title,
			"referrer": '/' + mdreferrer_title,
			"referrer_title": mdreferrer_title,
			"element_content": '',
			"element_id": '',
			"element_name": '',
			"element_type": '',
			"failMessage": '',
		}

		// 通过伪装成image对象，传递给后端，防止跨域
		let img = new Image(1, 1);
		// let src = `http://aaa/api/test.gif?args=${encodeURIComponent(args)}`;
		img.src = src;

		// css实现的埋点
		// .link:active::after {
		//   content: url('http://www.example.com?action=yourdata')
		// }

		let src = 'https://log.vmeeting.cn/1.gif?' + args + '&properties=' + encodeURI(JSON.stringify(properties));
		img.src = src;
		console.log('调用了新的埋点')
	},

	/**
	 * 获取外部medial平台token
	 * @param {外部token} url 
	 * @param {用户名} client_id 
	 * @param {密码} client_secret 
	 * @param {函数参数} func
	 */
	queryMedicalAccesstoken(url, client_id, client_secret, func) {
		var req_url = url + "/uaa/oauth/token?grant_type=client_credentials";
		//在请求头信息中携带Basic认证信息
		var basic = client_id + ':' + client_secret;
		var authentication = 'Basic ' + base64gb2312.encode64gb2312(basic);
		console.log(req_url, authentication);

		axios.post(req_url, null, {
			headers: {
				'Authorization': authentication,
				'content-type': 'application/x-www-form-urlencoded'
			}
		}).then(res => {
			console.log('token : ' + res.data.data.access_token);
        func(res.data.data.access_token);
		})
	},


	// 解密
aesDecrypt(encryptedData) {
	var key = CryptoJS.enc.Base64.parse("YTJsdVoyUnZiVzVsZEE9PQ==");
  
  // 初始化向量，转换为 WordArray 格式
  var iv = CryptoJS.enc.Base64.parse('YTJsdVoyUnZiVzVsZEE9PQ==');
	// AES 解密，指定模式为 CBC，并提供初始化向量
	var decryptedData = CryptoJS.AES.decrypt(encryptedData, key, {
		mode: CryptoJS.mode.CBC,
		iv: iv,
		padding: CryptoJS.pad.Pkcs7
	}).toString(CryptoJS.enc.Utf8);
	return decryptedData;
  }

}
